import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { ConfirmationComponent } from '../../../../shared/components/confirmation/confirmation.component';
import { ConfirmationModel } from '../../../../shared/model/confirmation.model';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { IssueCustomerMessage } from '../../model/issue-customer-message.model';
import { IssueUIMessages } from '../../model/issue-ui.messages';
import { IssueService } from '../../service/issue.service';

@Component({
  selector: 'site-specific-message-details-dialog',
  templateUrl:
    'console/app-js/modules/issue/components/site-specific-message-details/site-specific-message-details-dialog.component.html'
})
export class SiteSpecificDialogComponent extends APIOperableComponent {
  public isActive = true;
  public activeStatus = 'Active';
  @Input('opened') opened = false;
  @Input('messageModel') messageModel: IssueCustomerMessage;
  @Input('hasMessages') hasMessages = false;
  @Output() closed = new EventEmitter<any>();
  protected messageFormVisible = false;
  public addMessage = false;
  protected today = new Date(
    new Date().toLocaleDateString('en-US', { timeZone: 'America/New_York' })
  );
  protected disableSaveButton = true;
  protected isEdited = false;

  protected messageType = [
    {
      id: 'serviceRequestCreation',
      value: 'Service Request Creation'
    }
  ];

  protected defaultMessageType = this.messageType[0];

  constructor(
    private dialogService: UIDialogService,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private issueService: IssueService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnChanges(): void {
    if (
      this.messageModel !== undefined &&
      (this.messageModel.startDate === undefined ||
        this.messageModel.startDate === 'Not Set')
    ) {
      this.messageModel.startDate = this.today;
    }
  }

  checkValidation() {
    let valid = [];
    if (
      this.messageModel.messageText !== undefined &&
      (this.messageModel.messageText.length === 0 ||
        this.messageModel.messageText.length > 500)
    ) {
      valid.push('length');
    }
    if (this.validateDatesCheck()) {
      valid.push('date');
    }
    if (valid.length > 0) {
      this.disableSaveButton = true;
    } else {
      this.disableSaveButton = false;
    }
  }

  validateDatesCheck() {
    return (
      this.messageModel.startDate !== undefined &&
      this.messageModel.startDate !== null &&
      (this.messageModel.endDate !== undefined &&
        this.messageModel.endDate !== null) &&
      this.messageModel.startDate >= this.messageModel.endDate
    );
  }

  public close() {
    this.messageFormVisible = false;
    this.disableSaveButton = true;
    this.closed.emit(this.isEdited);
    this.isEdited = false;
    this.hasMessages = false;
  }

  public toggleForm(addMessage) {
    this.addMessage = addMessage;
    if (this.messageModel.startDate !== undefined) {
      this.messageModel.startDate = new Date(this.messageModel.startDate);
    }
    if (this.messageModel.endDate !== undefined) {
      this.messageModel.endDate = new Date(this.messageModel.endDate);
    }
    this.messageFormVisible = !this.messageFormVisible;
    this.checkValidation();
  }

  public open() {
    this.opened = true;
  }

  onDeleteMessage(): void {
    if (this.hasMessages) {
      this.messageModel.endDate = new Date(
        new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })
      );
      this.startProgress();
      this.issueService.putMessage(this.messageModel).subscribe(
        result => {
          if (result.responseCode === 200) {
            this.finishProgress();
            this.onAPISuccess(IssueUIMessages.DELETE_MESSAGE_SUCCESS);
            this.isEdited = true;
            this.close();
          } else {
            this.finishProgress();
            this.onAPIError(IssueUIMessages.DELETE_MESSAGE_ERROR);
          }
        },
        () => {
          this.onAPIError(IssueUIMessages.DELETE_MESSAGE_ERROR);
        }
      );
    }
  }

  openDeleteDialog() {
    this.dialogService
      .open(ConfirmationComponent, [
        {
          provide: ConfirmationModel,
          useValue: new ConfirmationModel(
            IssueUIMessages.DELETE_MESSAGE_TITLE,
            IssueUIMessages.DELETE_MESSAGE_CONFIRMATION
          )
        }
      ])
      .then(confirmed => {
        if (confirmed) {
          this.onDeleteMessage();
        }
      });
  }

  public submit() {
    if (!this.disableSaveButton) {
      this.startProgress();
      if (this.addMessage) {
        // TODO need to update this when we add message display type logic
        this.messageModel.messageDisplayType = this.messageType[0].id;

        this.issueService.postMessage(this.messageModel).subscribe(
          res => {
            if (res.result && res.status === 'Completed') {
              res = res.result;
            }
            if (res.responseCode === 200) {
              this.onAPISuccess(IssueUIMessages.UPDATE_ISSUE_SUCCESS);
            } else {
              this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
            }
          },
          err => {
            this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
          }
        );
      } else {
        this.issueService.putMessage(this.messageModel).subscribe(
          res => {
            if (res.result && res.status === 'Completed') {
              res = res.result;
            }
            if (res.responseCode === 200) {
              this.onAPISuccess(IssueUIMessages.UPDATE_ISSUE_SUCCESS);
            } else {
              this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
            }
          },
          err => {
            this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
          }
        );
      }
      this.isEdited = true;
      this.hasMessages = true;
      this.messageFormVisible = false;
      this.disableSaveButton = true;
      this.finishProgress();
    }
  }

  updateMessage(value: string) {
    this.messageModel.messageText = value;
    this.checkValidation();
  }

  updateStartDate(event) {
    this.messageModel.startDate = event;
    this.checkValidation();
  }

  updateEndDate(event) {
    this.messageModel.endDate = event;
    this.checkValidation();
  }

  valueChanged(value: Boolean): void {
    if (value) {
      this.isActive = false;
      this.activeStatus = 'Inactive';
    } else {
      this.isActive = true;
      this.activeStatus = 'Active';
    }
  }
}
